/*
定義値
*/
// ブレイクポイント
export const BREAKPOINT_PC = 1025
export const BREAKPOINT_SP = 1024
